export const PortalModalsActionTypes = {
  PORTAL_MODALS_FETCH_REQUEST: 'PORTAL_MODALS_FETCH_REQUEST',
  PORTAL_MODALS_FETCH_SUCCESS: 'PORTAL_MODALS_FETCH_SUCCESS',
  PORTAL_MODALS_FETCH_FAILURE: 'PORTAL_MODALS_FETCH_FAILURE',
  PORTAL_MODALS_CLEAR: 'PORTAL_MODALS_CLEAR',
};
